import type { Connection } from "@solana/web3.js";
import { getMarinadePoolProgram } from "@stepfinance/liquidity";
import BigNumber from "bignumber.js";

import { MARINADE_SOL_PDA, MARINADE_STATE_ADDRESS } from "./types";

export const calculateUnstakeFee = async (connection: Connection, lamportsToObtain: BigNumber): Promise<number> => {
  const marinadeProgram = getMarinadePoolProgram(connection);
  const state = await marinadeProgram.account.state.fetch(MARINADE_STATE_ADDRESS);

  const lamportsAvailable = new BigNumber(await connection.getBalance(MARINADE_SOL_PDA)).minus(
    state.rentExemptForTokenAcc.toNumber(),
  );

  // if trying to get more than existing
  if (lamportsToObtain.isGreaterThanOrEqualTo(lamportsAvailable)) {
    return state.liqPool.lpMaxFee.basisPoints;
  }
  // result after operation
  const lamportsAfter = lamportsAvailable.minus(lamportsToObtain);
  // if GTE target => min fee
  if (lamportsAfter.isGreaterThanOrEqualTo(state.liqPool.lpLiquidityTarget.toNumber())) {
    return state.liqPool.lpMinFee.basisPoints;
  } else {
    const delta = state.liqPool.lpMaxFee.basisPoints - state.liqPool.lpMinFee.basisPoints;
    return (
      state.liqPool.lpMaxFee.basisPoints -
      proportional(new BigNumber(delta), lamportsAfter, state.liqPool.lpLiquidityTarget.toNumber()).toNumber()
    );
  }
};

export function proportional(amount: BigNumber, numerator: BigNumber, denominator: number): BigNumber {
  if (denominator === 0) {
    return amount;
  }
  return amount.multipliedBy(numerator).dividedBy(denominator);
}
